import DirectionsCarOutlined from "@mui/icons-material/DirectionsCarOutlined";
import Inventory2Outlined from "@mui/icons-material/Inventory2Outlined";
import LocalShippingOutlined from "@mui/icons-material/LocalShippingOutlined";
import AssessmentOutlined from "@mui/icons-material/AssessmentOutlined";
import AdminPanelSettingsOutlined from "@mui/icons-material/AdminPanelSettingsOutlined";
import FolderCopyOutlined from "@mui/icons-material/FolderCopyOutlined";
import AddLocationAltOutlined from "@mui/icons-material/AddLocationAltOutlined";
import EventAvailableOutlined from "@mui/icons-material/EventAvailableOutlined";
import RouteOutlined from "@mui/icons-material/RouteOutlined";
import HubOutlined from "@mui/icons-material/HubOutlined";
import BusinessOutlined from "@mui/icons-material/BusinessOutlined";
import AddBoxOutlined from "@mui/icons-material/AddBoxOutlined";
import ViewInArOutlined from "@mui/icons-material/ViewInArOutlined";
import AllInboxOutlined from "@mui/icons-material/AllInboxOutlined";
import OpenInFullOutlined from "@mui/icons-material/OpenInFullOutlined";
import AssignmentIndOutlined from "@mui/icons-material/AssignmentIndOutlined";
import MovingOutlined from "@mui/icons-material/MovingOutlined";
import HistoryOutlined from "@mui/icons-material/HistoryOutlined";
import FindInPageOutlined from "@mui/icons-material/FindInPageOutlined";
import WarehouseOutlined from "@mui/icons-material/WarehouseOutlined";
import AirportShuttleOutlined from "@mui/icons-material/AirportShuttleOutlined";
import DeviceThermostatOutlined from "@mui/icons-material/DeviceThermostatOutlined";
import ThermostatAutoOutlined from "@mui/icons-material/ThermostatAutoOutlined";
import AssignmentLateOutlined from "@mui/icons-material/AssignmentLateOutlined";
import ManageSearchOutlined from "@mui/icons-material/ManageSearchOutlined";
import NotificationImportantOutlined from "@mui/icons-material/NotificationImportantOutlined";
import MoveToInboxOutlined from "@mui/icons-material/MoveToInboxOutlined";
import GroupOutlined from "@mui/icons-material/GroupOutlined";
import PersonAddAltOutlined from "@mui/icons-material/PersonAddAltOutlined";
import FactCheckOutlined from "@mui/icons-material/FactCheckOutlined";
import MiscellaneousServicesOutlined from "@mui/icons-material/MiscellaneousServicesOutlined";
import MarkEmailUnreadOutlined from "@mui/icons-material/MarkEmailUnreadOutlined";
import CalendarTodayOutlined from "@mui/icons-material/CalendarTodayOutlined";

export const navigationIcons = {
  NAV_FLEET: DirectionsCarOutlined,
  NAV_EXPEDITION: Inventory2Outlined,
  NAV_TRANSPORT: LocalShippingOutlined,
  NAV_REPORTS: AssessmentOutlined,
  NAV_ADMINISTRATION: AdminPanelSettingsOutlined,
  NAV_VEHICLE_DOCUMENTS: FolderCopyOutlined,
  NAV_CAR_NODE_ASSIGNMENT: AddLocationAltOutlined,
  NAV_ACTIVE_SHIPMENTS: LocalShippingOutlined,
  NAV_DELIVERY_SCHEDULE: EventAvailableOutlined,
  NAV_ROUTES: RouteOutlined,
  NAV_NODES: HubOutlined,
  NAV_CLIENTS: BusinessOutlined,
  NAV_CREATE_BIN: AddBoxOutlined,
  NAV_CARGO_OVERVIEW: ViewInArOutlined,
  NAV_CARGO_VOLUMES: AllInboxOutlined,
  NAV_OVERSIZED_PACKAGES: OpenInFullOutlined,
  NAV_ASSIGN_ROUTE: AssignmentIndOutlined,
  NAV_ACTIVE_TRANSPORTS: MovingOutlined,
  NAV_TRANSPORT_HISTORY: HistoryOutlined,
  NAV_INVOICE_SEARCH: FindInPageOutlined,
  NAV_NODE_CARGO: WarehouseOutlined,
  NAV_VEHICLE_CARGO: AirportShuttleOutlined,
  NAV_VEHICLE_TEMPERATURE: DeviceThermostatOutlined,
  NAV_NODE_TEMPERATURE: ThermostatAutoOutlined,
  NAV_UNDELIVERED_REPORT: AssignmentLateOutlined,
  NAV_PACKAGE_HISTORY: ManageSearchOutlined,
  NAV_TEMPERATURE_ALERTS: NotificationImportantOutlined,
  NAV_PICKUP_CARGO: MoveToInboxOutlined,
  NAV_USERS: GroupOutlined,
  NAV_USER_ADD: PersonAddAltOutlined,
  NAV_REASONS: FactCheckOutlined,
  NAV_SERVICES: MiscellaneousServicesOutlined,
  NAV_CUSTOMER_NOTIFICATIONS: MarkEmailUnreadOutlined,
  CALENDAR: CalendarTodayOutlined,
} as const;
